/* eslint-disable camelcase */
import { _QueryResources } from '@/lib/datx-jsonapi-react';
import { LectureProfile } from '@/resources/LectureProfile';

export const queryLectureProfilesByLectureId = (lectureId: string) => {
  return lectureId
    ? ([
        LectureProfile,
        {
          include: 'profile',
          sort: 'position',
          filter: {
            lecture_id: lectureId,
          },
        },
      ] as _QueryResources<LectureProfile>)
    : null;
};

export const queryAllLectureProfilesByLectureId = (lectureId: string) => {
  return lectureId
    ? ([
        LectureProfile,
        {
          include: 'profile',
          sort: 'position',
          filter: {
            lecture_id: lectureId,
          },
          loadAll: true,
        },
      ] as _QueryResources<LectureProfile>)
    : null;
};
